<po-page-dynamic-search
  [p-actions]="pageActions"
  [p-filters]="searchFilters"
  [p-literals]="searchLiterals"
  p-concat-filters="true"
  (p-quick-search)="onQuickSearch($event)"
  (p-advanced-search)="onAdvancedSearch($event)"
  (p-change-disclaimers)="onChangeDisclaimers($event)"
>
  <div class="users-access-selection" *ngIf="selectedUsernames.length">
    <po-tag p-type="info" [p-value]="selectedUsernames.length + ' selecionado(s)'"></po-tag>
    <span *ngIf="hiddenSelectedCount" class="users-access-hidden-selection">{{ hiddenSelectedCount }} fora desta lista</span>
    <po-button p-kind="tertiary" p-size="small" p-label="Limpar seleção" (p-click)="clearSelection()"></po-button>
  </div>

  <po-table
    [p-columns]="columns"
    [p-items]="items"
    [p-actions]="tableActions"
    p-actions-right="true"
    p-selectable="true"
    p-striped="true"
    p-sort="true"
    p-spacing="small"
    [p-height]="tableFit.height"
    [p-loading]="loading"
    [p-show-more-disabled]="allLoaded"
    [p-loading-show-more]="loadingShowMore"
    [p-literals]="{ noData: 'Nenhum usuário neste recorte' }"
    (p-sort-by)="onSortBy($event)"
    (p-show-more)="onShowMore()"
    (p-selected)="onRowSelected($event)"
    (p-unselected)="onRowUnselected($event)"
    (p-all-selected)="onAllSelected()"
    (p-all-unselected)="onAllUnselected()"
  >
    <ng-template p-table-cell-template let-column="column" let-row="row">
      <ng-container *ngIf="column.property === 'tribeName'">
        <span [class.users-access-muted]="!row.tribeName">{{ row.tribeName || "—" }}</span>
      </ng-container>

      <ng-container *ngIf="column.property === 'areaName'">
        <span *ngIf="row.areaId" [title]="row.areaName">{{ areaShortName(row) }}</span>
        <span *ngIf="!row.areaId" class="users-access-muted">—</span>
      </ng-container>

      <ng-container *ngIf="column.property === 'roles'">
        <div class="users-access-roles" *ngIf="userRoles(row) as roles">
          <span *ngFor="let role of roles" [title]="role"><po-tag [p-value]="roleLabel(role)" [p-color]="roleColor(role)" [p-text-color]="roleTextColor(role)"></po-tag></span>
          <span *ngIf="!roles.length" class="users-access-muted">—</span>
        </div>
      </ng-container>
    </ng-template>
  </po-table>
</po-page-dynamic-search>

<app-user-edit #userEdit [tribes]="tribes" [areas]="areas" [catalog]="accessCatalog" (saved)="reloadAll()"></app-user-edit>

<!-- Ações em lote -->
<po-modal #bulkGrantModal p-title="Conceder acesso" p-size="lg">
  <p class="users-access-bulk-intro">
    Acessos a conceder a <strong>{{ selectedUsernames.length }} usuário(s)</strong>. Os que dependem de outro concedem a dependência junto.
  </p>
  <div class="po-row">
    <po-checkbox-group
      *ngFor="let g of grantGroups; trackBy: trackBulkGroup"
      class="po-sm-12 po-md-4"
      [name]="'bulkGrant-' + g.group"
      [p-label]="g.label"
      [p-columns]="1"
      [p-options]="g.options"
      [ngModel]="g.selected"
      (ngModelChange)="onBulkGrantChange(g.group, $event)"
      [p-disabled]="bulkProcessing"
    ></po-checkbox-group>
  </div>
  <po-modal-footer>
    <po-button p-label="Cancelar" p-kind="secondary" (p-click)="bulkGrantModal.close()" [p-disabled]="bulkProcessing"></po-button>
    <po-button p-label="Conceder" p-kind="primary" (p-click)="confirmBulkGrant()" [p-disabled]="!bulkGrantRoles.length" [p-loading]="bulkProcessing"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #bulkRevokeModal p-title="Revogar acesso" p-size="lg">
  <p *ngIf="!revokeGroups.length">Nenhum dos usuários selecionados tem acessos do catálogo.</p>
  <ng-container *ngIf="revokeGroups.length">
    <p class="users-access-bulk-intro">
      Acessos a revogar de <strong>{{ selectedUsernames.length }} usuário(s)</strong>. Só aparecem os que algum deles tem.
    </p>
    <div class="po-row">
      <po-checkbox-group
        *ngFor="let g of revokeGroups; trackBy: trackBulkGroup"
        class="po-sm-12 po-md-4"
        [name]="'bulkRevoke-' + g.group"
        [p-label]="g.label"
        [p-columns]="1"
        [p-options]="g.options"
        [ngModel]="g.selected"
        (ngModelChange)="onBulkRevokeChange(g.group, $event)"
        [p-disabled]="bulkProcessing"
      ></po-checkbox-group>
    </div>
  </ng-container>
  <po-modal-footer>
    <po-button p-label="Cancelar" p-kind="secondary" (p-click)="bulkRevokeModal.close()" [p-disabled]="bulkProcessing"></po-button>
    <po-button p-label="Revogar" p-kind="primary" p-danger="true" (p-click)="confirmBulkRevoke()" [p-disabled]="!bulkRevokeRoles.length" [p-loading]="bulkProcessing"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #bulkMoveModal p-title="Mover para área" p-size="md">
  <po-combo
    name="bulkMoveToArea"
    p-label="Área de destino"
    p-placeholder="Digite para buscar por área ou tribe"
    p-required
    p-field-label="label"
    p-field-value="value"
    [p-filter-service]="areaCombo"
    [(ngModel)]="bulkMoveToAreaId"
    [p-disabled]="bulkProcessing"
  >
    <ng-template p-combo-option-template let-option>
      <span>{{ option.label }}</span>
      <span class="area-combo-tribe">{{ option.tribeName }}</span>
    </ng-template>
  </po-combo>
  <po-modal-footer>
    <po-button p-label="Cancelar" p-kind="secondary" (p-click)="bulkMoveModal.close()" [p-disabled]="bulkProcessing"></po-button>
    <po-button p-label="Mover" p-kind="primary" (p-click)="confirmBulkMove()" [p-disabled]="!bulkMoveToAreaId" [p-loading]="bulkProcessing"></po-button>
  </po-modal-footer>
</po-modal>
